import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ScenarioChart from 'Components/ComponentLibrary/Organisms/ScenarioChart';
import ViewScenarioButtonPicker from '../ViewScenarioButtonPicker';

const styles = theme => ({
  root: {},
  chartWrapper: {
    padding: theme.spacing(2),
  },
});

const ActiveScenarioChartContent = ({ className, classes }) => {
  const { clientDashboardResource } = useDashboardContext();

  return (
    <Box className={classNames(classes.root, className)}>
      <Box className={classes.chartWrapper}>
        <ScenarioChart
          height={200}
          resource={clientDashboardResource}
        />
        <ViewScenarioButtonPicker />
      </Box>
    </Box>
  );
};

ActiveScenarioChartContent.defaultProps = {
  className: '',
};

ActiveScenarioChartContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ActiveScenarioChartContent);
